// frontend/src/components/NavigationBar.js
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Tabs,
  Tab,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Overview', path: '/dashboard/overview' },
  { label: 'Trading', path: '/dashboard/trading' },
  { label: 'Portfolio', path: '/dashboard/portfolio' },
  { label: 'Analytics', path: '/dashboard/analytics' },
  { label: 'Market', path: '/dashboard/market' },
];

const NavigationBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);

  const currentTab = navItems.findIndex((item) =>
    location.pathname.startsWith(item.path)
  );

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to="/dashboard"
          sx={{ flexGrow: 1, textDecoration: 'none', color: 'inherit' }}
        >
          Trading Bot Dashboard
        </Typography>

        {!isMobile && (
          <Tabs
            value={currentTab !== -1 ? currentTab : false}
            textColor="inherit"
            indicatorColor="secondary"
          >
            {navItems.map((item, index) => (
              <Tab
                key={item.label}
                label={item.label}
                component={Link}
                to={item.path}
              />
            ))}
          </Tabs>
        )}

        {isMobile && (
          <>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {navItems.map((item) => (
                <MenuItem
                  key={item.label}
                  component={Link}
                  to={item.path}
                  onClick={handleMenuClose}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;


// import React from 'react';
// import Navbar from 'react-bootstrap/Navbar';
// import Nav from 'react-bootstrap/Nav';
// import Container from 'react-bootstrap/Container';
// import LinkContainer from 'react-router-bootstrap/LinkContainer';
// // import { Navbar, Nav, Container } from 'react-bootstrap/Navbar';
// // import { LinkContainer } from 'react-router-bootstrap';

// const NavigationBar = () => {
//   return (
//     <Navbar bg="dark" variant="dark" expand="lg">
//       <Container fluid>
//         <LinkContainer to="/dashboard">
//           <Navbar.Brand>Trading Bot Dashboard</Navbar.Brand>
//         </LinkContainer>
//         <Navbar.Toggle aria-controls="dashboard-navbar-nav" />
//         <Navbar.Collapse id="dashboard-navbar-nav">
//           <Nav className="me-auto">
//             <LinkContainer to="/dashboard/overview">
//               <Nav.Link>Overview</Nav.Link>
//             </LinkContainer>
//             <LinkContainer to="/dashboard/trading">
//               <Nav.Link>Trading</Nav.Link>
//             </LinkContainer>
//             <LinkContainer to="/dashboard/portfolio">
//               <Nav.Link>Portfolio</Nav.Link>
//             </LinkContainer>
//             <LinkContainer to="/dashboard/analytics">
//               <Nav.Link>Analytics</Nav.Link>
//             </LinkContainer>
//             <LinkContainer to="/dashboard/market">
//               <Nav.Link>Market</Nav.Link>
//             </LinkContainer>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// export default NavigationBar;